<template>
  <div class="animated revealUp">
    <b-modal hide-footer hide-header hide-backdrop no-close-on-esc no-close-on-backdrop ref="sendEmail" id="sendEmail">
      <div class="modal-header mb-3 pt-0 pl-0 pr-0">
        <button type="button" class="close" v-on:click="hideModal('sendEmail')">
          ×
        </button>
      </div>
      <h5 class="font-weight-bold text-blue text-center">
        Are you sure you want to send this invoice to vendor?
      </h5>
      <div class="d-flex mx-auto justify-content-center">
        <button :disabled="disableYesButton" @click.prevent="onClickYes()" class="btn-blue" title="Yes">
          Yes
        </button>
        <button @click.prevent="onClickNo()" class="btn btn-outline-grey btn-default" title="No">
          No
        </button>
      </div>
    </b-modal>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("purchase") }} {{ $t("order") }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $t("purchase") }} {{ $t("order") }}
          {{ $tc("incinematic") }}
        </div>
      </div>
      <div class="d-flex">
        <div>
          <router-link v-if="$can('create', 'Purchase Order')" variant="default" class="btn-blue"
            to="/fnb/add-purchase-order">{{ $tc("add") }}</router-link>
        </div>

        <div class="col-3">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item v-for="(list, listIndex) in viewingnumbers" :key="listIndex"
              @click="onDropDownChangeValue(list.name)" href="#">{{ list.name }}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper pt-0 mt-2">
      <div class="d-flex justify-content-between align-items-center py-3">
        <div class="mr-2 w-25">
          <b-form-input v-debounce:600="getPurchaseOrderList" v-model="searchValue" type="search"
            placeholder="Search..."></b-form-input>
        </div>

        <div class="dropdown-curve-container w-50">
          <label :class="cinema_id ? 'shift-up' : ''">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
          <multiselect :options="Cinemas" v-model="selectedCinema" :searchable="true" label="cine_name"
            track-by="cine_id" @select="onSelectCinema($event)" @remove="onSelectCinema($event, 'remove')"
            :showLabels="false">
          </multiselect>
        </div>

        <div class="d-flex align-items-center justify-content-between w-100 ml-2">
          <FilterByStatusDropdown2 :onSelect="(searchFilter) => {
            getPurchaseOrderList(e, searchFilter);
          }
            " class="mx-2" />
          <div class="row">
            <div class="col-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <button class="btn-clearDate" v-if="fromDate" v-on:click="fromDate = ''">
                    ✖
                  </button>
                  <Datepicker :monday-first="true" v-model="fromDate" ref="programaticOpen" :value="fromDate"
                    v-validate="'required'" typeable></Datepicker>
                  <label :class="fromDate ? 'active' : ''">{{
                    $t("fromdate")
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <button class="btn-clearDate" v-if="toDate" v-on:click="toDate = ''">
                    ✖
                  </button>
                  <Datepicker :monday-first="true" v-model="toDate" ref="programaticOpen" :value="toDate"
                    v-validate="'required'" typeable :disabledDates="{ to: fromDate }"></Datepicker>
                  <label :class="toDate ? 'active' : ''">{{
                    $t("todate")
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-2">
              <button @click="getPurchaseOrderList" class="btn-blue">
                Fetch
              </button>
            </div>
          </div>

          <div v-if="purchaseOrders && purchaseOrders.length > 0" class="d-flex justify-content-end align-items-center">
            <!-- <div style="white-space: nowrap">{{ $t("download") }} as:</div> -->
            <a v-if="excelFile" :href="getCinemaBaseURL(this.cinema_id) + excelFile" target="_blank"
              title="Download as Excel" download>
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" class="mx-1" />
            </a>
          </div>
          <button class="btnj btn-gridView mr-3" v-if="GridViewFlag" :class="gridView ? 'active' : ''"
            v-on:click="viewType('gridView')"></button>
          <button class="btnj btn-listView" v-if="GridViewFlag" :class="listView ? 'active' : ''"
            v-on:click="viewType('listView')"></button>
        </div>
      </div>

      <!-- LIST VIEW -->
      <table class="list-view-table text-center" v-if="listView">
        <thead>
          <tr>
            <th class="text-left">
              <span class="pr-5">{{ $tc("status", 1) }}</span>
            </th>
            <th class="text-left">{{ $t("Receipt Status") }}</th>
            <th class="text-left">
              <img v-if="orderAscending" @click="
                onSortValue('orderno', (orderAscending = !orderAscending))
                " src="@/assets/img/icons/asc.svg" class="cursor-pointer" width="15px" height="20px" />
              <img v-else @click="
                onSortValue('orderno', (orderAscending = !orderAscending))
                " src="@/assets/img/icons/desc.svg" class="cursor-pointer" width="15px" height="20px" />
              {{ $t("ponumber") }}
            </th>
            <th class="text-left">
              <img v-if="dateAscending" @click="onSortValue('date', (dateAscending = !dateAscending))"
                src="@/assets/img/icons/asc.svg" class="cursor-pointer" width="15px" height="20px" />
              <img v-else @click="onSortValue('date', (dateAscending = !dateAscending))"
                src="@/assets/img/icons/desc.svg" class="cursor-pointer" width="15px" height="20px" />
              {{ $t("date") }}
            </th>
            <th class="text-left">{{ $tc("cinema", 1) }}</th>
            <th class="text-left">{{ $tc("vendor", 1) }}</th>
            <th class="text-right">
              {{ $t("total") }} {{ $t("order_value") }}
            </th>
          </tr>
        </thead>

        <tbody v-if="purchaseOrders.length > 0">
          <template v-for="(purchaseOrder, purchaseOrderList) in purchaseOrders">
            <tr :key="purchaseOrderList">
              <td>
                <div class="d-flex justify-content-start align-items-center">
                  <b-dropdown v-if="
                    $can('update', 'Purchase Order') &&
                    !purchaseOrder['suppl_po_ref']
                  " right variant="edit" id="dropdown-dropup" size="sm" no-caret>
                    <b-dropdown-item @click="
                      goToRoute('/fnb/add-supp-purchase-order', purchaseOrder)
                      " :title="'View Seat Layout'">
                      Create Suppliment PO
                    </b-dropdown-item>
                  </b-dropdown>
                  <StatusDot :status="purchaseOrder.po_is_approved == 'Y' &&
                    purchaseOrder.po_is_active === 'Y'
                    ? 'draft'
                    : purchaseOrder.po_is_approved == 'N'
                      ? 'unapproved'
                      : purchaseOrder.po_is_active === 'Y'
                        ? 'active'
                        : 'inactive'
                    " />
                  <i class="icon-eye icon clickable-icon ml-2" @click="
                    goToRoute('/fnb/view-purchase-order', purchaseOrder)
                    " style="cursor: pointer" v-b-tooltip="'View'" tabindex="0"></i>
                  <i v-if="
                    purchaseOrder.po_lock !== 'Y' &&
                    purchaseOrder.transfer_stock_id === null &&
                    $can('update', 'Purchase Order')
                  " class="edit-pen icon clickable-icon ml-2" @click="
                    goToRoute('/fnb/edit-purchase-order', purchaseOrder)
                    " style="cursor: pointer" v-b-tooltip="'Edit'" tabindex="0"></i>
                  <div v-if="
                    purchaseOrder.po_is_approved == 'N' &&
                    $can('delete', 'Purchase Order') &&
                    checkRoleForPoApproval
                  " class="icon clickable-icon ml-2" @click="
                    approvePurchaseOder(purchaseOrderList, purchaseOrder)
                    " style="cursor: pointer" title="Approve">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="black"
                      class="bi bi-check2-circle" viewBox="0 0 16 16">
                      <path
                        d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                      <path
                        d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
                    </svg>
                  </div>
                  <a target="_blank" class="btn-transparent" title="Download as PDF" style="margin-left: 5px"
                    @click="handlePdfDownlaod(purchaseOrder)" download>
                    <img src="@/assets/img/icons/pdf-icon.svg" height="auto" width="25" style="cursor: pointer" />
                  </a>
                  <div class="btn" @click="showHideDetails(purchaseOrder)" style="cursor: pointer"
                    v-b-tooltip="'View PO'" tabindex="0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#4682B4"
                      class="bi bi-view-list" viewBox="0 0 16 16">
                      <path
                        d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2zm0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14z" />
                    </svg>
                  </div>
                </div>
              </td>
              <td class="text-left">
                <span v-if="purchaseOrder.transfer_stock_id !== null">
                  {{ purchaseOrder.transfer_status }}
                </span>
                <span v-else>
                  {{
                    purchaseOrder.po_is_approved == "Y" &&
                      purchaseOrder.po_is_active === "Y"
                      ? "Approve"
                      : purchaseOrder.po_is_approved == "N" &&
                        purchaseOrder.po_is_active === "Y"
                        ? "Pending"
                        : purchaseOrder.po_is_approved == "N" &&
                          purchaseOrder.po_is_active === "N"
                          ? "Pending"
                          : "Inactive"
                  }}
                </span>
              </td>
              <td class="text-left" :class="[
                purchaseOrder.transfer_stock_id !== null ? 'text-blue' : '',
              ]">
                {{ purchaseOrder.po_number }}
              </td>
              <td class="text-left">{{ purchaseOrder.po_date | dateparse }}</td>
              <td class="text-left">{{ purchaseOrder.cine_name }}</td>
              <td class="text-left" :class="[
                purchaseOrder.transfer_stock_id !== null ? 'text-blue' : '',
              ]">
                {{ purchaseOrder.v_name }}
              </td>
              <td class="text-right">
                {{ parseFloat(purchaseOrder.po_total_amount).toFixed(4) }}
              </td>
              <!-- <td>
              <div class="d-flex justify-content-end align-items-center">
                <StatusDot
                  :status="
                    purchaseOrder.po_is_approved == 'Y' &&
                    purchaseOrder.po_is_active === 'Y'
                      ? 'draft'
                      : purchaseOrder.po_is_approved == 'N'
                      ? 'unapproved'
                      : purchaseOrder.po_is_active === 'Y'
                      ? 'active'
                      : 'inactive'
                  "
                />
                <div>
                  <b-dropdown right variant="edit" class="ml-4">
                    <b-dropdown-item
                      v-if="
                        purchaseOrder.po_lock !== 'Y' &&
                        purchaseOrder.transfer_stock_id === null &&
                        $can('update', 'Purchase Order')
                      "
                      @click="
                        goToRoute('/fnb/edit-purchase-order', purchaseOrder)
                      "
                    >
                      <span class="edit-pen"></span>
                      {{ $t("edit") }}
                    </b-dropdown-item>

                    <b-dropdown-item
                      @click="
                        goToRoute('/fnb/view-purchase-order', purchaseOrder)
                      "
                    >
                      <span class="icon-eye mr-1"></span>
                      {{ $t("view") }}
                    </b-dropdown-item> -->
              <!-- Approve Purchase Order -->
              <!-- <b-dropdown-item
                      v-if="
                        purchaseOrder.po_is_approved == 'N' &&
                        $can('update', 'Purchase Order')
                      "
                      @click="
                        approvePurchaseOder(purchaseOrderList, purchaseOrder)
                      "
                    >
                      <span class="edit-pen"></span>
                      {{ $t("Approve") }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </td> -->
            </tr>
            <tr :style="purchaseOrder.more ? '' : 'display: none'" :key="purchaseOrder.po_number">
              <td colspan="100%">
                <b-collapse v-model="purchaseOrder.more">
                  <!-- LIST VIEW -->

                  <table class="list-view-table text-center" style="width: 100%">
                    <thead>
                      <tr>
                        <th class="text-left">{{ $tc("rawmaterials", 2) }}</th>
                        <th class="text-center">{{ $t("quantity") }}</th>
                        <th class="text-center">{{ $t("uom") }}</th>
                        <th class="text-center">Remarks</th>
                        <th class="text-center">Rate</th>
                        <th class="text-center">Net Total</th>
                        <th class="text-center">Tax</th>
                        <th class="text-center">Gross Total</th>
                      </tr>
                    </thead>

                    <tbody v-if="
                      purchaseOrder.allPoItems &&
                      purchaseOrder.allPoItems.length > 0
                    " class="m-0 p-0" style="margin-bottom: 0">
                      <tr v-for="(
purchaseOrderDetail, purchaseOrderList
                        ) in purchaseOrder.allPoItems" :key="purchaseOrderList">
                        <td class="text-left">
                          {{ purchaseOrderDetail.rm_name || "-" }}
                        </td>
                        <td class="text-center">
                          {{ purchaseOrderDetail.poi_qty }}
                        </td>
                        <td class="text-center">
                          {{ purchaseOrderDetail.uom_short_form }}
                        </td>
                        <td class="text-center">
                          {{ purchaseOrderDetail.poi_remarks }}
                        </td>
                        <td class="text-center">
                          {{
                            parseFloat(purchaseOrderDetail.poi_rate).toFixed(4)
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            parseFloat(purchaseOrderDetail.poi_price).toFixed(4)
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            parseFloat(
                              purchaseOrderDetail.poi_tax_amount
                            ).toFixed(4)
                          }}
                        </td>
                        <td class="text-center">
                          {{
                            parseFloat(
                              purchaseOrderDetail.poi_total_amount
                            ).toFixed(4)
                          }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="8">
                          <NoRecords />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-collapse>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-pagination v-model="currentPage" :total-rows="rows" @change="onChangePagination($event)" :per-page="perPage"
      aria-controls="my-table"></b-pagination>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div class="col-md-4 col-lg-4 col-xl-3 px-0" v-for="(purchaseOrder, purchaseOrderkey) in purchaseOrders"
        :key="purchaseOrderkey">
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ purchaseOrder.po_number }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item v-if="
                  purchaseOrder.po_lock !== 'Y' &&
                  $can('update', 'Purchase Order')
                " @click="goToRoute('/fnb/edit-purchase-order', purchaseOrder)">
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/fnb/view-purchase-order', purchaseOrder)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <StatusDot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";
import ReportsService from "@/services/ReportsService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown2 from "@/components/Partials/FilterByStatusDropdown2.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import { BASEURL } from "@/config/index";
import { encryptString } from "@/helper/collection"
import { getCinemaBaseURL } from "@/services/Api"

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown2,
    NoRecords,
  },
  data() {
    return {
      BASEURL,
      purchasOrderDetails: {
        cinema_id: "",
        v_id: "",
        po_grand_total: "",
        po_date: null,
        po_sub_total_amount: "",
        po_lock: false,
        po_is_active: true,
        po_number: "",
      },
      fetchedCinema: [],
      VendorsData: [],
      CinemaData: [],

      RawMaterialsList: [],
      VendorList: [],
      Cinemas: [],
      RawMaterials: [],
      Vendors: [],
      measurements: [],
      selectedCinema: "",
      selectedRawMaterial: "",
      selectedVendor: "",
      selectedQuantity: "",
      selectedUom: "",
      po_number: "",
      totalTax: 0,
      disableYesButton: false,
      currencyData: [],
      selectedRow: {},

      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      orderAscending: true,
      cinema_id: null,
      multipleCinemaId: null,
      dateAscending: true,
      gridView: false,
      listView: true,
      purchaseOrders: [],
      searchValue: "",
      excelFile: null,
      fromDate: "",
      toDate: "",
    };
  },
  watch: {
    searchValue: function (newValue, oldValue) {
      if (String(newValue).length == 0) {
        this.searchValue = "";
        this.getPurchaseOrderList();
      }
    },
  },
  mounted() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj;
    this.getCinemasList(this.cinema_id);
  },
  beforeMount() {
    this.getviewingnumber();
  },
  computed: {
    checkRoleForPoApproval() {
      const { role_id } = this.secureStore.get("USINFO");
      let globalPoAccessRole =
        this.$store.getters.STOCK_APPROVAL_ACCESS_TO_ROLES || [];
      if (globalPoAccessRole && globalPoAccessRole.length) {
        if (role_id == 1) {
          return true;
        } else {
          return globalPoAccessRole.includes(role_id);
        }
      } else {
        return true;
      }
    },
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
    ...mapGetters(["getPurchaseOrderFileName"]),
  },
  created() { },
  methods: {
    getCinemaBaseURL,
    showHideDetails: function (po) {
      if (po.hasOwnProperty("more")) {
        po.more = !po.more;
      } else po.more = true;

      this.purchaseOrders.forEach((p) => {
        if (po.po_id != p.po_id) {
          p.more = false;
        }
      });

      this.$forceUpdate();
    },
    onSelectCinema: function (event, type = "add") {
      if (type == "remove") {
        this.selectedCinema = "";
        this.selectedCinemaName = "";
        this.cinema_id = null;
        this.multipleCinemaId = [];
      } else {
        this.selectedCinema = event;
        this.selectedCinemaName = event.cine_name;
        this.cinema_id = event.cine_id;
        this.multipleCinemaId = [...event].map((x) => x.cine_id);
      }
    },
    getCinemasList: function (cinema_id) {
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.forEach((x) => {
              if (x.cine_id === cinema_id) {
                this.selectedCinema = { ...x };
                this.CinemaData.push(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getSingleCinema: function (cinema_id) {
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
      };
      this.CinemaData = [];
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.forEach((x) => {
              if (x.cine_id == cinema_id) {
                this.fetchedCinema.push(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getVendorsList: function (v_id) {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Vendors = data.Records;
            this.Vendors.forEach((x) => {
              if (x.v_id === v_id) {
                this.purchasOrderDetails.v_id = v_id;
                this.selectedVendor = x.v_name;
                this.VendorsData.push(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getRawMaterials: function (Materials, vendor_id) {
      let loader = this.$loading.show();
      let payload = { vendor_id };

      return PosFnbService.GetVendorRateDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RawMaterials = data.Records;
            Materials.forEach((x) => {
              this.totalTax += x.poi_tax_amount;
              this.purchasOrderDetails.po_sub_total_amount =
                this.purchasOrderDetails.po_total_amount - this.totalTax;

              let array = data.Records.filter(({ rm_id }) => rm_id === x.rm_id);

              let poi_gross_amount = (x.poi_total_amount / x.poi_qty).toFixed(
                4
              );
              let poi_tax_amount_single = (
                x.poi_tax_amount / x.poi_qty
              ).toFixed(4);

              this.RawMaterialsList.push({
                rm_name: x.rm_name,
                rm_id: x.rm_id,
                rm_description: x.rm_description,
                poi_qty: x.poi_qty.toFixed(4),
                po_quantity: x.poi_qty.toFixed(4),
                poi_price: x.poi_price.toFixed(4),
                poi_gross_amount: poi_gross_amount,
                poi_total_amount: x.poi_total_amount.toFixed(4),
                poi_tax_percent: x.poi_tax_in_percentage,
                poi_tax_amount_single: poi_tax_amount_single,
                poi_remarks: x.poi_remarks || "",
                uom_unit: x.uom_unit,
                uom_id: x.uom_id,
                poi_id: x.poi_id,
                poi_is_active: true,
                vendor_rate_id: x.vendor_rate_id,
                singlItemPrice: x.poi_price / x.poi_qty,
                SelectedRawMaterial: array.length > 0 ? array[0] : {},
                TotalTax: this.totalTax,
                FinalSubTotal: this.purchasOrderDetails.po_sub_total_amount,
              });
            });
            this.$store.dispatch("FETCH_PURCHASE_ORDER_DETAILS", {
              PurchasOrderDetails: this.purchasOrderDetails,
              VendorsDetails: this.VendorsData,
              CinemasDetails: [{ ...this.selectedCinema }],
              RawMaterialsDetails: this.RawMaterialsList,
              BasicDetails: {
                curr_code: this.currencyData.curr_code,
                TotalTax: this.totalTax,
                FinalSubTotal: this.purchasOrderDetails.po_sub_total_amount,
              },
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1500);
        });
    },
    getPdfUrl: function () {
      let payload = {
        PurchasOrderDetails: this.purchasOrderDetails,
        VendorsDetails: this.VendorsData,
        CinemasDetails: this.fetchedCinema,
        RawMaterialsDetails: this.RawMaterialsList,
        BasicDetails: {
          curr_code: this.currencyData.curr_code,
          TotalTax: this.totalTax,
          FinalSubTotal: this.purchasOrderDetails.po_sub_total_amount,
        },
        cinema_id: this.cinema_id,
      };
      let loader = this.$loading.show();
      ReportsService.GetPurchaseOrderList(payload)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            this.$store.dispatch("SET_FILE_VALUE", payload);
            setTimeout(() => {
              window.open(this.getCinemaBaseURL(this.cinema_id) + data.Record, "_blank");
              setTimeout(() => loader.hide(), 1100);
            }, 6000);
          }
          else {
            loader.hide()
          }
        })
        .catch((err) => {
          console.log(err);
          loader.hide()
        })
    },
    handlePdfDownlaod(purchaseOrder) {
      // console.log("po_id: purchaseOrder.po_id",{po_id: purchaseOrder.po_id})
      let currentCinemaId = this.cinema_id
      this.getOrdersDetails({
        po_id: purchaseOrder.po_id,
        CinemasDetails: this.cinemaData,
        cinema_id: currentCinemaId
      });
    },
    getOrdersDetails: function (payload) {
      console.log("getOrdersDetails Run", payload);
      let loader = this.$loading.show();
      this.purchasOrderDetails = {
        cinema_id: "",
        v_id: "",
        po_grand_total: "",
        po_date: null,
        po_sub_total_amount: "",
        po_lock: false,
        po_is_active: true,
        po_number: "",
      };
      this.VendorsData = [];
      this.CinemaData = [];
      this.RawMaterialsList = [];
      this.totalTax = 0;
      PosFnbService.GetPurchaseOrderDetails(payload)
        .then((response) => {
          // console.log("getOrdersDetails Run complete", payload);
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            //console.log("dataaaaaaaaaa", data);
            this.purchasOrderDetails = {
              ...this.purchasOrderDetails,
              ...data.Records[0],
              po_date: new Date(data.Records[0].po_date),
              po_lock: data.Records[0].po_lock == "Y",
              po_is_active: data.Records[0].po_is_active == "Y",
            };
            this.getVendorsList(this.purchasOrderDetails.v_id);
            this.getSingleCinema(this.purchasOrderDetails.cinema_id);
            this.getRawMaterials(
              data.Records,
              this.purchasOrderDetails.v_id
            ).then(() => {
              // let loader = this.$loading.show();
              // setTimeout(() => {
              //   window.open(
              //     this.BASE_URL + this.getPurchaseOrderFileName,
              //     "_blank"
              //   );
              //   setTimeout(() => loader.hide(), 1100);
              // }, 6000);
              this.getPdfUrl();
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1100);
        });
    },

    // getOrdersDetails: function(payload) {
    //   console.log("getOrdersDetails Run", payload);
    //   let loader = this.$loading.show();
    //   this.purchasOrderDetails = {
    //     cinema_id: "",
    //     v_id: "",
    //     po_grand_total: "",
    //     po_date: null,
    //     po_sub_total_amount: "",
    //     po_lock: false,
    //     po_is_active: true,
    //     po_number: "",
    //   };
    //   this.VendorsData = [];
    //   this.CinemaData = [];
    //   this.RawMaterialsList = [];
    //   this.totalTax = 0;

    //   PosFnbService.GetPurchaseOrderDetails(payload)
    //     .then((response) => {
    //       console.log("getOrdersDetails Run complete", payload);
    //       const { data } = response;
    //       if (data && data.status && data.Records.length > 0) {
    //         console.log("dataaaaaaaaaa", data);
    //         this.purchasOrderDetails = {
    //           ...this.purchasOrderDetails,
    //           ...data.Records[0],
    //           po_date: new Date(data.Records[0].po_date),
    //           po_lock: data.Records[0].po_lock == "Y",
    //           po_is_active: data.Records[0].po_is_active == "Y",
    //         };
    //         return Promise.all([
    //           this.getVendorsList(this.purchasOrderDetails.v_id),
    //           this.getCinemasList(this.purchasOrderDetails.cinema_id),
    //           this.getRawMaterials(data.Records, this.purchasOrderDetails.v_id),
    //         ]);
    //       } else {
    //         this.$toasted.show(data.message);
    //         return Promise.reject("No data found");
    //       }
    //     })
    //     .then(() => {
    //       window.open(this.BASE_URL + this.getPurchaseOrderFileName, "_blank");
    //     })
    //     .catch((error) => {
    //       console.error("Error fetching order details:", error);
    //     })
    //     .finally(() => {
    //       setTimeout(() => loader.hide(), 1100);
    //     });
    // },

    hideModal: function (modal) {
      if (modal == "sendEmail") {
        this.$bvModal.hide("sendEmail");
      }
    },
    openConfirmEmailModal: function (purchaseOrder) {
      this.selectedRow = purchaseOrder;
      //console.log("this.selectedRow",this.selectedRow)
      this.$refs["sendEmail"].show();
    },
    onClickNo() {
      this.$refs["sendEmail"].hide();
    },
    onClickYes() {
      let loader = this.$loading.show();
      this.disableYesButton = true;
      let payload = {
        po_id: this.selectedRow.po_id,
        po_number: this.selectedRow.po_number,
        pdffilename: this.getPurchaseOrderFileName,
        vendor_name: this.selectedRow.v_name,
      };
      PosFnbService.sendInvoiceToVendor(payload)
        .then((response) => {
          const { data } = response;
          this.$refs["sendEmail"].hide();
          this.disableYesButton = false;
          loader.hide();
          if (data.status) {
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.disableYesButton = false;
          loader.hide();
          this.$refs["sendEmail"].hide();
          this.$toasted.show("Something went wrong");
        });
    },

    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        //   console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        //  console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getPurchaseOrderList();
      } else {
        this.currentPage = event;
        this.getPurchaseOrderList();
      }
    },
    onSortValue: function (column, ascending) {
      if (column == "orderno") {
        if (ascending == false) {
          this.purchaseOrders = this.purchaseOrders.sort(function (a, b) {
            return b.po_number - a.po_number;
          });
        } else {
          this.purchaseOrders = this.purchaseOrders.sort(function (a, b) {
            return a.po_number - b.po_number;
          });
        }
      } else if (column == "date") {
        if (ascending == false) {
          this.purchaseOrders = this.purchaseOrders.sort(function (a, b) {
            return new Date(a.po_date) - new Date(b.po_date);
          });
        } else {
          this.purchaseOrders = this.purchaseOrders.sort(function (a, b) {
            return new Date(b.po_date) - new Date(a.po_date);
          });
        }
      }
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    goToRoute: function (path, { po_number, po_id }) {
      let queryObj = {
        po_number: po_number,
        po_id: po_id,
      }


      if (["/fnb/edit-purchase-order", "/fnb/view-purchase-order", "/fnb/add-supp-purchase-order"].includes(path)) {
        queryObj["cinema_id"] = encryptString(String(this.cinema_id))
      }


      this.$router.push({
        path: path,
        query: queryObj,
      });
    },
    approvePurchaseOder: function (purchaseOrderIndex, purchaseOrder) {
      console.log("approvePurchaseOder", {
        purchaseOrderIndex,
        purchaseOrder,
      });
      let { po_id } = purchaseOrder;
      let payload = { po_id, cinema_id: this.cinema_id };

      PosFnbService.ApprovePurchaseOrder(payload)
        .then((response) => {
          const { data } = response;

          if (data && data.status) {
            this.getPurchaseOrderList();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getPurchaseOrderList: function (e, searchFilter = "ALL") {
      if (!this.cinema_id) {
        return this.$toasted.show("Please select cinema")
      }
      let loader = this.$loading.show();
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        fromDate: this.fromDate,
        toDate: this.toDate,
        cinema_id: this.cinema_id,
        searchFilter: searchFilter,
      };
      PosFnbService.GetAllPurchaseOrders(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.purchaseOrders = data.Records;
            this.excelFile = data.FinalExcelFile;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue =
                this.selectedvalue < 10 ? 10 : this.selectedvalue;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.purchaseOrders = [];
            this.rows = data.totalRows;
            this.selectedvalue = data.totalRows;
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/PurchaseOrderComponents/purchaseOrder.vue